<template>
  <div class="reference-doc-section">
    <div class="reference-doc-header">
      <div class="reference-doc-header-content">
        <h3 class="reference-doc-title">
          Barème Convention collective
          <span class="reference-doc-required" aria-hidden="true">*</span>
        </h3>
      </div>
    </div>

    <AwSkeleton v-if="loading" class="h-20 w-full rounded-lg" />
    <div v-else class="reference-doc-content">
      <DocumentItem
        :document-id="displayDocumentId"
        document-type="company_remuneration_reference"
        :context="uploadContext"
        :allow-delete="false"
        @update:document-id="handleDocumentIdUpdate"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import DocumentItem from "../document/DocumentItem.vue";

const props = defineProps<{
  referenceDocumentIds: string[];
  companySiren: string;
  loading: boolean;
  companyId: string;
}>();

const emit = defineEmits<{
  upload: [documentId: string];
}>();

const displayDocumentId = computed(() => {
  const ids = props.referenceDocumentIds;
  return ids.length > 0 ? ids[0] : undefined;
});

const uploadContext = computed(() => ({
  companyId: props.companyId,
  siren: props.companySiren,
}));

function handleDocumentIdUpdate(documentId: string | undefined) {
  if (!documentId) return;
  emit("upload", documentId);
}
</script>

<style scoped lang="scss">
.reference-doc-section {
  margin-top: 24px;
}

.reference-doc-header {
  margin-bottom: 12px;
}

.reference-doc-header-content {
  flex: 1;
}

.reference-doc-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.reference-doc-required {
  color: var(--danger);
}

.reference-doc-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
